<script lang="ts">
	//UI
	//Utils
	//Types
	//Props
	export let active = false;
	export let hover = false;
	//Constants
	//Variables
	//Functions
	//Do

</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	width="100%"
	height="100%"
	viewBox="0 0 27.239 26.002">
	<g>
		<g>
			<path
				class:active
				class:hover
				d="M421.845 231.323a.523.523 0 0 1-.524-.524v-8.736c0-6.774-3.4-10.354-9.83-10.355s-9.832 3.582-9.832 10.355v8.737a.524.524 0 1 1-1.048 0v-8.736c0-7.352 3.863-11.4 10.878-11.4s10.88 4.051 10.88 11.4v8.736a.524.524 0 0 1-.524.523z"
				transform="translate(-397.87 -210.66)" />
		</g>
		<g>
			<path
				class:active
				class:hover
				d="M421.913 249.106a5.866 5.866 0 0 1-11.733 0z"
				transform="translate(-402.427 -228.967)" />
		</g>
		<g>
			<path
				class:active
				class:hover
				d="M422.094 249.154H395.9a.524.524 0 0 1 0-1.048h26.191a.524.524 0 1 1 0 1.048z"
				transform="translate(-395.379 -228.491)" />
		</g>
	</g>
</svg>

<style lang="scss">
	path {
		transition: all 0.5s;
		fill: #bcbfc3;

		&.hover {
			fill: var(--default-hover-btn-1);
		}

		&.active {
			fill: var(--signature-blue) !important;
		}
	}

</style>
